import { useEffect } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";
import {
  clearAllStickyFilters,
  syncStickyFiltersOwner,
} from "../utils/stickyFilterStorage";

/**
 * Keeps sticky filters scoped to the signed-in Clerk user.
 * Clears them on sign-out and when a different user signs in on the same tab.
 */
export default function useSyncStickyFiltersOwner() {
  const { isLoaded, isSignedIn } = useAuth();
  const { user } = useUser();

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (!isSignedIn) {
      clearAllStickyFilters();
      return;
    }

    syncStickyFiltersOwner(user?.id);
  }, [isLoaded, isSignedIn, user?.id]);
}
